// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"2327": "bb4c22d14ded","7141": "cdec85e31733","9685": "37b0a85f4dfe",}[chunkId] + ".css"
}